// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global responsive styles */

/* Reduce content margin on mobile */

@media (max-width: 768px) {
  /* Ant Design Card body padding */
  .ant-card-body {
    padding: 12px !important;
  }

  .ant-card-head {
    padding: 0 12px !important;
    min-height: 40px !important;
  }

  .ant-card-head-title {
    font-size: 14px !important;
  }

  .ant-card-extra {
    font-size: 12px !important;
  }

  /* Table adjustments */
  .ant-table {
    font-size: 13px !important;
  }

  .ant-table-thead > tr > th {
    padding: 8px !important;
  }

  .ant-table-tbody > tr > td {
    padding: 8px !important;
  }

  /* Modal full-width on mobile */
  .ant-modal {
    max-width: calc(100vw - 32px) !important;
    margin: 16px auto !important;
  }

  /* Statistic smaller on mobile */
  .ant-statistic-title {
    font-size: 12px !important;
  }

  .ant-statistic-content {
    font-size: 20px !important;
  }
}

/* Filters row - stack on mobile */

.responsive-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

@media (max-width: 768px) {
  .responsive-filters {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .responsive-filters .ant-input-search,
  .responsive-filters .ant-picker,
  .responsive-filters .ant-select {
    width: 100% !important;
  }
}

/* Page header bar - stack on very small screens */

.page-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/styles/responsive.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,oCAAoC;;AACpC;EACE,iCAAiC;EACjC;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,sBAAsB;EACtB;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,+BAA+B;EAC/B;IACE,wCAAwC;IACxC,4BAA4B;EAC9B;;EAEA,gCAAgC;EAChC;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kCAAkC;;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;;;IAGE,sBAAsB;EACxB;AACF;;AAEA,kDAAkD;;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV","sourcesContent":["/* Global responsive styles */\n\n/* Reduce content margin on mobile */\n@media (max-width: 768px) {\n  /* Ant Design Card body padding */\n  .ant-card-body {\n    padding: 12px !important;\n  }\n\n  .ant-card-head {\n    padding: 0 12px !important;\n    min-height: 40px !important;\n  }\n\n  .ant-card-head-title {\n    font-size: 14px !important;\n  }\n\n  .ant-card-extra {\n    font-size: 12px !important;\n  }\n\n  /* Table adjustments */\n  .ant-table {\n    font-size: 13px !important;\n  }\n\n  .ant-table-thead > tr > th {\n    padding: 8px !important;\n  }\n\n  .ant-table-tbody > tr > td {\n    padding: 8px !important;\n  }\n\n  /* Modal full-width on mobile */\n  .ant-modal {\n    max-width: calc(100vw - 32px) !important;\n    margin: 16px auto !important;\n  }\n\n  /* Statistic smaller on mobile */\n  .ant-statistic-title {\n    font-size: 12px !important;\n  }\n\n  .ant-statistic-content {\n    font-size: 20px !important;\n  }\n}\n\n/* Filters row - stack on mobile */\n.responsive-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .responsive-filters {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .responsive-filters .ant-input-search,\n  .responsive-filters .ant-picker,\n  .responsive-filters .ant-select {\n    width: 100% !important;\n  }\n}\n\n/* Page header bar - stack on very small screens */\n.page-header-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
